export default {
    alreadyPresent: 'alreadyPresent',
    invalidFile: 'invalidFile',
    uploadProblem: 'uploadProblem',
    userCancelled: 'userCancelled',
    uploadLimit: 'uploadLimit',
}